import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const toArray = <T>(payload: unknown): T[] => {
    if (Array.isArray(payload)) return payload as T[];
    const data = payload as any;
    if (!data || typeof data !== 'object') return [];

    if (Array.isArray(data.items)) return data.items as T[];
    if (Array.isArray(data.data)) return data.data as T[];
    if (Array.isArray(data.results)) return data.results as T[];
    if (Array.isArray(data.tenants)) return data.tenants as T[];
    if (Array.isArray(data.users)) return data.users as T[];
    if (Array.isArray(data.groups)) return data.groups as T[];
    if (Array.isArray(data.idps)) return data.idps as T[];
    if (Array.isArray(data.apps)) return data.apps as T[];

    if (data.data && typeof data.data === 'object') {
        const nested = toArray<T>(data.data);
        if (nested.length > 0) return nested;
    }

    // Fallback: if response object contains any array field, use the first one.
    const firstArray = Object.values(data).find((value) => Array.isArray(value));
    if (Array.isArray(firstArray)) return firstArray as T[];

    return [];
};
